import { Box, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { DsText, DsTooltip, size } from "@mvp/design-system";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { formatDisplayDate } from "../../../utils/date";
import Icons from "../../../utils/icons";
import { useAppStore, useEffectiveDates, useEligibilityStore } from "./../../../hooks";

const useStyles = makeStyles((theme) => ({
    infoIcon: {
        color: "rgba(0, 0, 0, 0.6)",
        alignSelf: "center",
    },
    textMargin: {
        marginRight: size.xs(theme),
    },
    textNoDisplayDate: {
        color: theme.palette.grey[700]
    }
}));

export const EffectiveDateSummary: React.FC = () => {
    const classes = useStyles();
    const [t] = useTranslation();
    const { appStore: { planInfo } } = useAppStore();

    const { effectiveDates, isLoading, error } = useEffectiveDates(planInfo);
    const { eligibilityDispatch, eligibilityStore } = useEligibilityStore();
    const { effectiveStartDate } = eligibilityStore;

    useEffect(() => {
        if (!isLoading) {
            // only set the effective start date if there's only one option and it hasn't been set yet
            if (effectiveDates?.length === 1 && !effectiveStartDate) {
                eligibilityDispatch("setEffectiveStartDate", effectiveDates[0]);
            }
            // No need to present error with effective dates here, as the parent component handles it
        }
    }, [effectiveDates, isLoading]);

    const tooltipTitle = t("effectiveDates.explanation");

    const displayDate = effectiveStartDate ? formatDisplayDate(effectiveStartDate) : "MM/DD/YYYY";
    const displayDateClassName = effectiveStartDate ? classes.textMargin : `${classes.textMargin} ${classes.textNoDisplayDate}`;

    // if loading, show skeleton for date and info icon
    if (isLoading) {
        return (
            <Box display="flex">
                <Skeleton data-testid="skeleton-loading-text" animation="wave" width={115} className={classes.textMargin} />
                <Skeleton data-testid="skeleton-loading-icon" animation="wave" width={24} />
            </Box>
        );
    }

    return (
        <Box display="flex">
            <DsText variant="body2" className={displayDateClassName}>{displayDate}</DsText>
            <DsTooltip arrow
                title={<>{tooltipTitle}</>}
            >
                {error || effectiveDates?.length === 0 ? <></> : <Icons.InfoIcon className={classes.infoIcon} />}
            </DsTooltip>
        </Box>
    );
}